import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  InputAdornment,
  Button,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useForm } from "../../../hooks/useForm";
import moment from "moment";
import "moment/locale/es";
import { CboLocalidades } from "../../cbos/CboLocalidades";
import { afiliadoStartUpdate } from "../../../actions/afiliado";
import { useValidation } from "../../../hooks/useValidation";
import { actualizarDatosPersonales } from "../../../actions/afiliado";
import {
  ValidatorForm,
  TextValidator,
} from "react-material-ui-form-validator";
import { changeStepper } from "../../../actions/preAfiliado/stepper";
import { useLocation } from "react-router-dom";
import { saveAutopercepcionPorAfiliado } from "../../../actions/turnos/agenda";
import { afiliadoExternoStartUpdate, getDatosPreviosDeAfiliadoExterno } from "../../../actions/afiliadoExterno";
import { OBRAS_SOCIALES } from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  botonera: {
    marginTop: 25,
  },
  NroAfi: {
    fontSize: 15,
  },
  hideButton: {
    display: "none",
  },
}));

export const PanelDatosTurno = React.memo(({ autopercepcion = false, idObraSocial, setIdObraSocial }) => {

  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();
  const location = useLocation()

  const [cambioDatos, setCambioDatos] = React.useState(false);
  const { afiliado, datosCompletos } = useSelector(
    (state) => state.afiliacion
  );
  const { items: aportes } = useSelector(state => state.aportesPreafiliado);
  const { autopercepcionAfi } = useSelector(state => state.agenda);
  const [autoP, setAutoP] = React.useState('');
  const { step } = useSelector((state) => state.stepper);
  const { items: localidades } = useSelector((state) => state.localidades);


  const [
    formValues,
    ,
    reset,
    setearValor,
    ,
    setearValorDomicilio,
    ,
    ,
    setearVariosValores,
  ] = useForm(afiliado);

  const {
    apellido_y_nombre,
    carnet,
    parent,
    fecha_nacimiento,
    fecha_baja,
    //cobraCoseguro,
    domiciliosAfiliados: {
      calle,
      nro,
      telefono,
      celular,
      codigo_postal,
      mail,
      id_localidad,
    },
  } = formValues;

  const activeId = useRef(afiliado?.id_afiliado);

  const [
    valuesValidation,
    handleInputChangeValidation,
    resetValidation,
    setearValorValidation,
  ] = useValidation(afiliado);

  const [datosValidos, setDatosValidos] = useState(true);

  const [edad, setEdad] = useState(
    moment().diff(moment(fecha_nacimiento), "years", false)
  );

  useEffect(() => {
    if (afiliado && afiliado.id_afiliado !== activeId.current) {
      reset(afiliado);
      resetValidation(afiliado);
      setEdad(
        moment().diff(moment(afiliado?.fecha_nacimiento), "years", false)
      );
      activeId.current = afiliado.id_afiliado;
    }
  }, [afiliado, reset, resetValidation]);

  useEffect(() => {
    setDatosValidos(true);

    const valorValidado = Object.keys(valuesValidation).find(
      (key) => valuesValidation[key] === true
    );
    if (valorValidado) {
      setDatosValidos(false);
    }
    dispatch(actualizarDatosPersonales(datosValidos));
  }, [dispatch, valuesValidation, datosValidos]);

  useEffect(() => {
    if (aportes.length > 0) {
      setearValor("id_sit_revista", 0);
    }
  }, [aportes.length, setearValor])

  useEffect(() => {
    if (afiliado && afiliado.id_afiliado) {
      setAutoP(autopercepcionAfi?.apeNom);
    }
  }, [afiliado.id_afiliado, autopercepcionAfi]);

  //Traigo los datos que tengo almacenados si existen
  useEffect(() => {
    if (idObraSocial !== OBRAS_SOCIALES.OSPEDYC)
      dispatch(getDatosPreviosDeAfiliadoExterno(idObraSocial, afiliado));
  }, [dispatch]);

  //hasta aca manejo formulario con seleccion

  const validateEmail = (email) => {
    // let reg = new RegExp(`[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+`);
    let reg = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    if (reg.test(email) || email?.length === 0) {
      setearValorValidation("mail", false);
    } else {
      setearValorValidation("mail", true);
    }
  };

  const handleInputDomicilio = ({ target }) => {
    setCambioDatos(true);
    setearValorDomicilio(target.name, target.value);
  };

  const handleSubmit = () => {
    if (datosCompletos) {
      if (idObraSocial === OBRAS_SOCIALES.OSPEDYC) {
        afiliado.externo = false;
        if (cambioDatos)
          dispatch(afiliadoStartUpdate(formValues, location.pathname));
        dispatch(changeStepper(step + 1));
      } else {
        dispatch(afiliadoExternoStartUpdate(formValues, idObraSocial));
        dispatch(changeStepper(step + 1));
      }
    }
  };

  const handleSaveClick = () => {
    dispatch(saveAutopercepcionPorAfiliado(afiliado.id_afiliado, autoP));
  }
  const handleDateChange = (date) => {
    setearValor("fecha_nacimiento", date);
    setEdad(moment().diff(moment(date), "years", false));
  };

  const validadoresTelefono =
    celular?.length === 10
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageTelefono =
    celular?.length === 10
      ? ["Solo numeros", "Verifique su telefono", "Verifique su telefono"]
      : [
        "El telefono es requerido",
        "Solo numeros",
        "Verifique su telefono",
        "Verifique su telefono",
      ];

  const validadoresCelular =
    telefono?.length === 10
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageCelular =
    telefono?.length === 10
      ? ["Solo numeros", "Verifique su celular", "Verifique su celular"]
      : ["El celular es requerido", "Solo numeros", "Verifique su celular", "Verifique su celular"];

  const disabled = idObraSocial === OBRAS_SOCIALES.OSPEDYC ? (fecha_baja !== null || autopercepcion ? true : false) : false;

  const handleCPChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    const cp = e.target.value;
    if (cp === "" || reg.test(cp)) {
      const listaFiltrada = localidades.filter(loc => cp?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(cp));
      if (listaFiltrada?.length > 0) {
        const localidad = listaFiltrada[0];
        setearVariosValores({
          domiciliosAfiliados: {
            ...formValues.domiciliosAfiliados,
            codigo_postal: cp,
            id_provincia: localidad?.id_provincia,
            id_localidad: localidad?.id_localidad,
            id_seccional: localidad?.id_seccional
          }
        });
      } else {
        setearVariosValores({
          domiciliosAfiliados: {
            ...formValues.domiciliosAfiliados,
            codigo_postal: cp,
            id_provincia: "",
            id_localidad: "",
            id_seccional: ""
          }
        });
      }
    }
  };
  
  return (
    <>
      <ValidatorForm onSubmit={handleSubmit}>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <TextField
                margin="normal"
                InputProps={{
                  classes: {
                    input: classes.NroAfi,
                  },
                }}
                fullWidth={true}
                disabled={true}
                label="Nro. Afiliado"
                name="carnet"
                value={idObraSocial === OBRAS_SOCIALES.OSPEDYC ? `${carnet || ""}/${parent || ""}` : `${carnet || ""}`}
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={5}>
              <TextField
                margin="normal"
                fullWidth
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Apellido y Nombre"
                name="apellido_y_nombre"
                disabled={idObraSocial === OBRAS_SOCIALES.OSPEDYC}
                value={apellido_y_nombre}
                required={true}
                autoComplete="off"
                onChange={(e) => {
                  setearValor("apellido_y_nombre", e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecha_nacimiento"
                  label="Fec. Nac."
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  maxDate={new Date()} //maxDate
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={idObraSocial === OBRAS_SOCIALES.OSPEDYC}
                  value={
                    moment(fecha_nacimiento).isValid()
                      ? moment(fecha_nacimiento)
                      : 0
                  }
                  onChange={(date) => {
                    handleDateChange(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={2}>
              <TextField
                margin="normal"
                fullWidth
                label="Edad"
                value={`${edad || ""} Años`}
                autoComplete="off"
                disabled={true}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextValidator
                margin="normal"
                value={mail || ""}
                error={valuesValidation["mail"]}
                helperText={valuesValidation["mail"] && "Invalido"}
                disabled={disabled}
                onChange={(e) => {
                  handleInputDomicilio(e);
                  handleInputChangeValidation(e);
                }}
                onBlur={() => {
                  validateEmail(mail);
                }}
                //required={true}
                label="EMail"
                name="mail"
                autoComplete="off"
                fullWidth
                validators={["required", "isEmail"]}
                errorMessages={["El EMail es requerido", "Email invalido"]}
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                fullWidth
                margin="normal"
                value={celular || ""}
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                label="Cel. (10 dig. sin 0 ni 15)"
                disabled={disabled}
                name="celular"
                maxLength="10"
                autoComplete="off"
                validators={validadoresCelular}
                errorMessages={errorMessageCelular}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      0
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                fullWidth
                margin="normal"
                value={telefono || ""}
                onChange={(e) => {
                  handleInputDomicilio(e);
                }}
                label="Tel. (10 digitos sin 0)"
                disabled={disabled}
                name="telefono"
                autoComplete="off"
                validators={validadoresTelefono}
                errorMessages={errorMessageTelefono}
                maxLength="10"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      0
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextValidator
                margin="normal"
                value={calle || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Calle"
                name="calle"
                disabled={idObraSocial === OBRAS_SOCIALES.OSPEDYC}
                autoComplete="off"
                fullWidth
                onChange={handleInputDomicilio}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={nro || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Numero"
                name="nro"
                disabled={idObraSocial === OBRAS_SOCIALES.OSPEDYC}
                autoComplete="off"
                fullWidth
                onChange={handleInputDomicilio}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                value={codigo_postal || ""}
                label="Cod. Postal"
                disabled={idObraSocial === OBRAS_SOCIALES.OSPEDYC}
                name="codigo_postal"
                autoComplete="off"
                onChange={(e) => {
                  handleCPChange(e);
                  //handleInputChangeValidation(e);
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <CboLocalidades
                name="id_localidad"
                valor={id_localidad}
                cp={codigo_postal}
                disabled={true}
                notRequired={true}
              />
            </Grid>
            {autopercepcion &&
              <Grid item xs={12}>
                <TextValidator
                  margin="normal"
                  fullWidth
                  label="Nombre Autopercibido"
                  name="autoP"
                  value={autoP || ""}
                  autoComplete="off"
                  validators={["required"]}
                  errorMessages={["Este campo es obligatorio"]}
                  onChange={(e) => setAutoP(e.target.value)}
                  inputProps={{ maxLength: 200 }}
                />
              </Grid>
            }
          </Grid>
          <Button id="btnSubmitDatosTurnos" className={classes.hideButton} type="submit">
            Submit
          </Button>
          {autopercepcion &&
            <Button
              onClick={handleSaveClick}
              style={{ marginTop: 25 }}
              id="saveAutopercepcion"
              variant="contained"
              color="primary"
            >
              Guardar
            </Button>
          }
        </div>
      </ValidatorForm>
    </>
  );
});
